









import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class Popover extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly opened!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly top!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly right!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly centerContent!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly static!: boolean;

  @Prop({ type: String, default: "100%" })
  readonly maxWidth!: string;

  @Prop({ type: String, default: "100%" })
  readonly height!: string;

  @Prop({ type: String, default: "0 20px" })
  readonly padding!: string;
}
